export default "__VITE_ASSET__DUkdwYwS__"